module.exports = __webpack_public_path__ + "static/media/microsoft.c62abca7.png";